import { StrictMode, useEffect, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { KindeProvider } from '@kinde-oss/kinde-auth-react'
import { DesignSystemProvider } from '@neutheria/design-system'
import './styles/globals.css'
import App from './App'

function Root() {
  const [origin, setOrigin] = useState('')
  useEffect(() => { setOrigin(window.location.origin) }, [])
  if (!origin) return null

  const env = import.meta.env
  const domain = env.VITE_KINDE_DOMAIN as string | undefined
  const clientId = env.VITE_KINDE_CLIENT_ID as string | undefined

  // Without a Kinde domain + client id the SDK throws on mount. Render a
  // friendly setup screen instead — copy/paste-ready for whoever forgot.
  if (!domain || !clientId) {
    return (
      <DesignSystemProvider theme={{ glowColor: 'rgba(168, 85, 247, 0.18)', accentColor: '#7c3aed' }} background={true}>
        <div className="ds-login-bg">
          <div className="ds-login-card">
            <h1 className="ds-login-title">
              <span style={{ color: '#9ca3af', fontWeight: 400 }}>Neutheria </span>SuperFlow
            </h1>
            <div className="ds-login-divider" />
            <p className="ds-login-tagline">
              Kinde is not configured. Create a <code>.env.development.local</code> (dev) or <code>.env</code> (prod) in the project root with:
            </p>
            <pre style={{ fontSize: 11, background: 'rgba(0,0,0,0.05)', border: '1px solid rgba(0,0,0,0.1)', borderRadius: 8, padding: 12, overflow: 'auto' }}>{
`VITE_API_URL=http://localhost:8787
VITE_KINDE_DOMAIN=https://auth.neutheria.ch
VITE_KINDE_CLIENT_ID=...
VITE_KINDE_REDIRECT_URI=http://localhost:5173
VITE_KINDE_LOGOUT_REDIRECT_URI=http://localhost:5173
VITE_KINDE_AUDIENCE=https://api.superflow.neutheria.ch`
            }</pre>
            <div className="ds-login-footer">
              See <code>DEPLOYMENT.md</code> for the full setup. Restart the dev server after creating the file.
            </div>
          </div>
        </div>
      </DesignSystemProvider>
    )
  }

  return (
    <KindeProvider
      clientId={clientId}
      domain={domain}
      redirectUri={(env.VITE_KINDE_REDIRECT_URI as string) || origin}
      logoutUri={(env.VITE_KINDE_LOGOUT_REDIRECT_URI as string) || origin}
      audience={env.VITE_KINDE_AUDIENCE as string | undefined}
    >
      <DesignSystemProvider theme={{ glowColor: 'rgba(168, 85, 247, 0.18)', accentColor: '#7c3aed' }} background={false}>
        <App />
      </DesignSystemProvider>
    </KindeProvider>
  )
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Root />
  </StrictMode>
)
